import { cva } from 'class-variance-authority';

export const overlayRectangleVariants = cva(
  'absolute box-border flex flex-col overflow-hidden p-2 text-left no-underline [&>a]:no-underline',
  {
    variants: {
      // null values are placed here to fulfill the type - values are set in compoundVariants
      variant: {
        1: null,
        2: null,
        3: null,
        4: null,
      },
      horizontal: {
        left: null,
        right: null,
        center: null,
      },
      vertical: {
        top: 'top-[11%]',
        bottom: 'bottom-[11%]',
        center: null,
        stretch: null,
        'flex-start': null,
        'flex-end': null,
        // following vertical alignments are not available by drupal but menitioned in the type
        'space-between': null,
        left: null,
        right: null,
      },
      scaleDown: {
        false: null,
        true: 'scale-[0.42] md:scale-[0.45] lg:scale-[0.75]',
      },
    },
    compoundVariants: [
      {
        vertical: ['center', 'stretch', 'flex-start', 'flex-end'],
        className: 'top-1/2 -translate-y-1/2',
      },
      {
        variant: [1, 3],
        className: 'c_OverlaySmall',
      },
      {
        variant: [2, 4],
        className: 'c_OverlayMedium',
      },
      {
        variant: 1,
        horizontal: 'left',
        className: 'left-[2%] md:left-[5%]',
      },
      {
        variant: 1,
        horizontal: 'right',
        className: 'right-[2%] md:right-[5%]',
      },
      {
        variant: 2,
        horizontal: 'left',
        className: 'left-0',
      },
      {
        variant: 2,
        horizontal: 'right',
        className: 'right-0',
      },
      {
        variant: 3,
        horizontal: 'left',
        className: 'left-[5%]',
      },
      {
        variant: 3,
        horizontal: 'right',
        className: 'right-[5%]',
      },
      {
        variant: 4,
        horizontal: 'left',
        className: 'left-[5%] md:left-[2%]',
      },
      {
        variant: 4,
        horizontal: 'right',
        className: 'right-[5%] md:right-[2%]',
      },
      {
        horizontal: 'left',
        vertical: 'top',
        className: 'origin-top-left',
      },
      {
        horizontal: 'left',
        vertical: 'bottom',
        className: 'origin-bottom-left',
      },
      {
        horizontal: 'right',
        vertical: 'top',
        className: 'origin-top-right',
      },
      {
        horizontal: 'right',
        vertical: 'bottom',
        className: 'origin-bottom-right',
      },
      {
        horizontal: 'left',
        vertical: 'center',
        className: 'origin-left',
      },
      {
        horizontal: 'right',
        vertical: 'center',
        className: 'origin-right',
      },
    ],
  },
);
